import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { DataList, Spinner } from '@chakra-ui/react';
import { useShoppingCart } from '@client/providers/ShoppingCartProvider';
import { TEXT_STYLES } from '@client/theme';
import { formatCentsAsDollars } from '@heirloom/common/utils/priceDisplay';
export const ShoppingCartSummary = (props) => {
    const shoppingCart = useShoppingCart();
    return (_jsx(DataList.Root, { orientation: "horizontal", gap: 1.5, children: [
            {
                label: 'Subtotal',
                value: formatCentsAsDollars(shoppingCart.itemPriceTotal),
            },
            {
                label: 'Shipping',
                value: shoppingCart.shippingTotal
                    ? formatCentsAsDollars(shoppingCart.shippingTotal)
                    : '$0.00',
            },
            {
                label: 'Tax',
                value: (_jsxs(_Fragment, { children: [shoppingCart.taxTotal === null && (_jsx(_Fragment, { children: shoppingCart.taxCalcLoading ? (_jsx(Spinner, { size: "sm" })) : (props.pendingMessage) })), shoppingCart.taxTotal !== null &&
                            formatCentsAsDollars(shoppingCart.taxTotal)] })),
            },
        ].map(({ label, value }) => (_jsxs(DataList.Item, { color: props.textColor, children: [_jsx(DataList.ItemLabel, { minWidth: 75, textStyle: TEXT_STYLES.fieldLabel, color: props.textColor, children: label }), _jsx(DataList.ItemValue, { fontSize: 20, children: value })] }, label))) }));
};
